import axios from "axios";
import { storage } from "../utils/storage";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // timeout: 100000,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
});

api.interceptors.request.use((config) => {
  const token = storage.get("ntk");
  console.log("API TOKEN:", token);
  // const token =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwdWJsaWNfaWQiOjEsImV4cCI6MTc2NjIyNDAzNywidG9rZW5fdHlwZSI6ImVudHJ5X2dhdGUiLCJ1aWQiOiI5SWlxUUtBczFlNGpLODFRbVg5ZGM2ZWFvYmtqMldLRl9vNjNiWnpQbFl3PSJ9.WPEufE-gvJhNcsR_pHut3c7aWvVljY3sTa9EgO9hZXk";
  if (config.headers?.Authorization) {
    console.log(config.headers?.Authorization);
    return config;
  }

  if (!config.skipAuth && token) {
    config.headers.Authorization = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response?.status === 401) {
    //   storage.remove("ntk");
    //   window.location.href = "/";
    // }
    return Promise.reject(error);
  },
);

export default api;
